import { Component, Input } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { AddRecipientModalForm, createLabelVariablesConfig } from '../../model';

@Component({
  selector: 'multi-shipment-add-recipient-modal',
  templateUrl: './add-recipient-modal.component.html',
  styleUrls: ['./add-recipient-modal.component.scss'],
  standalone: false,
})
export class AddRecipientModalComponent {
  @Input({ required: true }) formGroup!: FormGroup<AddRecipientModalForm>;

  get noRatesTitleControl(): FormControl<string> {
    return this.formGroup.controls.shipping.controls.noRates.controls.title;
  }

  get noRatesBodyControl(): FormControl<string> {
    return this.formGroup.controls.shipping.controls.noRates.controls.body;
  }

  get messageLimitControl(): FormControl<number> {
    return this.formGroup.controls.giftNote.controls.messageLimit;
  }

  readonly titleVariables = createLabelVariablesConfig(['name', 'number']);
  readonly numberOnlyVariables = createLabelVariablesConfig(['number']);

  onStepDescriptionChange(control: FormControl<string>, content: string): void {
    control.setValue(content);
    control.markAsDirty();
  }
}
